import { useState } from "react";
import { message, ModalProps } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import api from "../../services/api";
import { PaymentModal } from "../Payment";
import { UserPlans } from "../../constants/plans";
import { ChoosePlanStep } from "./ChoosePlanStep";
import { Content, Loading, PlanModalStyled } from "./styles";
import { IClient, useClients } from "../../contexts/ClientsContext";

interface IUserPlanModal extends ModalProps {
  modalPlans?: any[];
  paymentData?: any;
  closeModal?: any;
  open?: boolean;
  setOpen?: any;
  setClientsSelected?: any;
  clientsSelected?: IClient[];
  userCount: number;
  paymentType: string;
  setPaymentType: Function;
  createConciergePlan: React.MouseEventHandler;
  clientsWithCancelRecurring?: IClient[];
  showPaymentModal?: boolean;
  setShowPaymentModal?: any;
  selectedPlan: any
  setSelectedPlan: any
}

var getStatus: NodeJS.Timeout;

export const UserPlanModal: React.FC<IUserPlanModal> = ({
  open,
  title,
  setOpen,
  onCancel,
  userCount,
  modalPlans,
  closeModal,
  paymentData,
  paymentType,
  setPaymentType,
  clientsSelected,
  showPaymentModal,
  setClientsSelected,
  createConciergePlan,
  setShowPaymentModal,
  clientsWithCancelRecurring,
  selectedPlan,
  setSelectedPlan,
  ...rest
}) => {
  const { selectedClient, getClients } = useClients();
  const [loading] = useState(false);
  const [closable] = useState(true);
  const isActive = selectedClient?.userPlanInfoVelotax?.active;
  const planBought = selectedClient?.userPlanInfoVelotax?.type ?? "";
  const isCancelRecurring = (clientsWithCancelRecurring || []).length > 0;

  const handleSuccess = (data: any) => {
    checkWasPaid(data.paymentId, 4);
  };

  const checkWasPaid = (id: string, delay: number = 2) => {
    let attempts = 0;

    getStatus = setInterval(async () => {
      api
        .get(
          `/clients/user/${selectedClient?.username}?userId=${selectedClient?._id}`
        )
        .then((res) => {
          if (res.data?.plan) {
            clearInterval(getStatus);
            message.success("Pagamento Confirmado com sucesso");
            closeModal();
            getClients();
          }
        })
        .finally(() => {
          attempts += 1;

          if (attempts > 100) {
            clearInterval(getStatus);
          }
        });
    }, delay * 1000);
  };
  return (
    <>
      {showPaymentModal ? (
        <PaymentModal
          hideDarfDownload
          show={showPaymentModal}
          onSucessPix={checkWasPaid}
          callDarf={(value: boolean) => {}}
          onSucessCreditCard={handleSuccess}
          planCurrent={UserPlans[selectedPlan]}
          clientSelected={clientsSelected?.[0]}
          createConciergePlan={createConciergePlan}
          disableCreditCardOption={(clientsSelected || [])?.length > 1}
          onCancel={() => {
            setShowPaymentModal(false);
            closeModal(false);
          }}
          paymentData={{
            ...paymentData,
            type: UserPlans[selectedPlan]?.type,
            isPlan: true,
          }}
          disableCreditCardMessage={
            (clientsSelected || [])?.length > 1
              ? "Para contratar via cartão, selecione apenas um cliente por vez"
              : ""
          }
        />
      ) : (
        <PlanModalStyled
          open={open}
          footer={null}
          destroyOnClose
          closable={closable}
          className="userPlanModal"
          title="Selecione o seu plano"
          onCancel={(e) => {
            setOpen(false);
            setClientsSelected([]);
          }}
          {...rest}
        >
          <Content>
            {loading && (
              <Loading>
                <LoadingOutlined color="var(--ant-primary-color)" size={24} />
              </Loading>
            )}

            <ChoosePlanStep
              isActive={isActive}
              userCount={userCount}
              planBought={planBought}
              selectedPlan={selectedPlan}
              selectedClient={selectedClient}
              setPaymentType={setPaymentType}
              setSelectedPlan={setSelectedPlan}
              isCancelRecurring={isCancelRecurring}
              clientsWithCancelRecurring={clientsWithCancelRecurring}
              handleAction={(e) => {
                setShowPaymentModal(true);
                setOpen(false);
              }}
            />
          </Content>
        </PlanModalStyled>
      )}
    </>
  );
};
